<template>
  <div style="display: block; padding: 0 8px">
    <el-button
      type="warning"
      @click="dialogVisible = true"
      circle
      icon="el-icon-plus"
      :disabled="loading"
    ></el-button>
    <el-dialog
      top="20vh"
      title="新增合約"
      :visible.sync="dialogVisible"
      @closed="handleDialogClose"
    >
      <el-card v-loading="dialogLoading">
        <el-form
          ref="formRef"
          style="display: flex; flex-direction: column; gap: 12px 0"
          :inline="true"
          class="dialog-contract"
          :model="params"
          @submit.native.prevent
        >
          <el-form-item class="dialog-contract-item" label="合約名稱" prop="name">
            <el-input v-model.trim="params.params.name" placeholder="請輸入合約名稱"></el-input>
          </el-form-item>
          <el-form-item class="dialog-contract-item" label="時效性" prop="type">
            <el-switch
              v-model="params.params.type"
              active-text="永久"
              :active-value="2"
              :inactive-value="1"
              inactive-text="1小時"
            >
            </el-switch>
          </el-form-item>
          <div style="display: flex; flex-direction: column; gap: 12px 0">
            <el-form-item class="dialog-contract-item" label="合約檔案">
              <Upload
                ref="uploadRef"
                :accept="'.pdf'"
                :payload="params"
                :data-obj="fileObj"
                :limitText="'檔案須為.pdf格式，限制不超過50MB'"
                :limit-file-count="1"
                :use-drag="false"
                :action="'file/fileUpload'"
                :auto-upload="false"
                :show-file-list="true"
                :form-on-loading-parent="dialogLoading"
                :btn-txt="'選擇合約'"
                :before-file-list="
                  params.fileInfo && params.fileInfo.length ? params.fileInfo[0].files : []
                "
              />
            </el-form-item>
          </div>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button type="warning" @click="handleSubmit" style="color: #4b4b4b">儲 存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { saveContract } from '@/api/contract'
import Upload from '@/views/ita/components/fileUpload.vue'
export default {
  name: 'AddContractDialog',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Upload,
  },
  data() {
    return {
      dialogLoading: false,
      dialogVisible: false,
      fileObj: { id: 40, type: 'contractInfo' },
      params: {
        fileInfo: [],
        params: {
          id: '',
          name: '',
          type: 1,
        },
      },
    }
  },
  methods: {
    handleDialogClose() {
      let refUpload = this.$refs['uploadRef']
      if (refUpload != undefined) {
        refUpload.clearFiles()
      }
      this.params = {
        fileInfo: [],
        params: {
          id: '',
          name: '',
          type: 1,
        },
      }
    },
    async handleSubmit() {
      let refUpload = this.$refs['uploadRef']
      let payload = await refUpload.combineFileAndPayload()
      const formatParams = {
        files: payload.fileInfo[0].files,
        type: payload.fileInfo[0].type,
        param: this.params.params,
      }
      if (!payload) {
        alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
        return false
      }

      if (!formatParams.param.name) {
        alert('尚未填寫合約名稱！')
        return false
      }
      if (!formatParams.files || formatParams.files.length == 0) {
        alert('尚未上傳合約檔案！')
        return false
      }

      if (!confirm(`確定要儲存資料?`)) return false
      this.dialogLoading = true
      await saveContract(formatParams)
        .then(resp => {
          if (resp.success) {
            this.dialogVisible = false
            this.$emit('on-refresh')
            this.$message({
              message: '新增合約成功',
              type: 'success',
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.dialogLoading = false
          refUpload.clearFiles()
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-contract {
  display: flex;
  flex-direction: column;
}
</style>
